import Button from '@ramsey-design-system/button';
import { MatcherVerificationStatus } from '../enums';
import { useMatcherButtonSize } from '../utils';

interface MatcherSubmitButtonProps {
  status: MatcherVerificationStatus;
}

function isVerifying(status: MatcherVerificationStatus) {
  return (
    MatcherVerificationStatus.verifyingCode === status ||
    MatcherVerificationStatus.redirecting === status
  );
}

export function MatcherSubmitButton({
  status
}: Readonly<MatcherSubmitButtonProps>) {
  const verifying = isVerifying(status);
  const buttonSize = useMatcherButtonSize();

  return (
    <Button
      type="submit"
      className="!w-full"
      fullWidthOnMobile={true}
      size={buttonSize}
      id="matcher_verify_my_code"
      data-testid="tax_matcher_verify_my_code_submit"
      loading={verifying}
      // Submitting the old code while a resend is in flight supersedes the code the user is about
      // to receive, which is what leaves them unable to verify even with a fresh code.
      disabled={status === MatcherVerificationStatus.resendingCode}
    >
      {verifying ? 'Verifying Code . . .' : 'Verify My Code'}
    </Button>
  );
}
